import React from 'react';
import { useTransition, type UseTransitionProps } from 'react-spring';
import JustificationContainer from '~/components/atom/JustificationContainer';
import DeletableItem from '../DeletableItem';
import type { InteractiveAppearance, Size } from '~/styles/constants';

export type Props = {
  appearance?: InteractiveAppearance;
  size?: Size;
  selectedValues: Array<string>;
  onRemoved: (item: string, index: number) => void;
};

/**
 * Used when selected options are strings
 */
const DeletableItems: React.FCC<Props> = ({
  selectedValues,
  size = 'medium',
  appearance = 'primary',
  onRemoved,
  ...rest
}) => {
  const transitionProps: UseTransitionProps = {
    config: { duration: 200 },
    from: { opacity: 0, transform: 'translateX(-10px)' },
    enter: { opacity: 1, transform: 'translateX(0px)' },
    leave: { opacity: 0, transform: 'translateX(-10px)' },
    keys: item => item,
  };

  const transitions = useTransition(selectedValues, transitionProps);

  if (selectedValues.length === 0) return null;

  return (
    <JustificationContainer
      wrap="wrap"
      gap="xxs"
      padding={[null, null, 'xxs', null]}
      {...rest}
    >
      {transitions((style, item, { key }, index) => {
        if (item)
          return (
            <DeletableItem
              key={key}
              onDelete={() => onRemoved(item, index)}
              size={size}
              label={item}
              appearance={appearance}
              style={style}
            />
          );
        return null;
      })}
    </JustificationContainer>
  );
};

export default DeletableItems;
